import { reqLogin, reqUserInfo } from '@/api/modules/login'
import router from '@/router'
import { rsaEncrypt } from '@/utils'
import { getToken, getUserInfo, removeToken, setToken, setUserInfo } from '@/utils/auth'

export const useUserStore = defineStore(
  // 唯一ID
  'user',
  () => {
    const token = ref(getToken())
    const userInfo: any = ref(getUserInfo())
    const userRoutes: any = ref([])

    function login(data: any) {
      return new Promise((resolve, reject) => {
        rsaEncrypt(data.password, data.username).then((res: any) => {
          const pubKeyUuid = res.uuid
          const params = {
            ...data,
            password: encodeURI(res.password),
            pubKeyUuid,
          }
          reqLogin(params).then((res: any) => {
            const user = res.data.user
            user.role = user.roleType === 1 ? 'admin' : 'user'
            token.value = res.data.token
            userInfo.value = user
            setToken(res.data.token)
            setUserInfo(user)
            resolve(res)
          }).catch((error: any) => {
            reject(error)
          })
        })
      })
    }
    // 获取用户信息
    function getInfo() {
      return new Promise((resolve, reject) => {
        reqUserInfo().then((res) => {
          userInfo.value = res.data
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    }
    function logout(redirect = router.currentRoute.value.fullPath) {
      // 清除 token 信息
      removeToken()
      token.value = ''
      userInfo.value = null
      userRoutes.value = []
      // 跳转到登录页
      router.push({
        name: 'login',
        query: {
          ...(router.currentRoute.value.name !== 'login' && { redirect }),
        },
      })
    }
    function setUserRoutes(routes: any) {
      userRoutes.value = routes
    }
    return {
      token,
      login,
      logout,
      getInfo,
      userInfo,
      userRoutes,
      setUserRoutes,
    }
  },
)
